import { TableRow } from "./TableRow";

type TableRowLoaderProps = {
  colCount: number;
  rowCount: number;
  colWidths?: string[];
  checkbox?: boolean;
};

export const TableRowLoader = ({
  colCount,
  rowCount,
  colWidths,
  checkbox,
}: TableRowLoaderProps): JSX.Element => {
  return (
    <>
      {[...Array(rowCount)].map((_, i) => (
        <TableRow
          checkbox={checkbox}
          skeleton
          colCount={colCount}
          colWidths={colWidths}
          key={i}
        />
      ))}
    </>
  );
};
